import { collections } from '@/schema'

export const currentPromotionInitiativeId = async () => {
  const { initiativeId } = await collections.configurations.findByIdWithFallback('Promotions', {
    initiativeId: 'noel-2025',
  })
  return initiativeId
}
